module.exports = __webpack_public_path__ + "static/media/miscellaneous.cbba93c7.svg";